export default __webpack_public_path__ + "static/media/box.784c2080.svg";